<template>
  <a :href="feed.link">
    <div class="card">
      <div class="card-image">
        <figure class="image is-4by3">
          <img v-bind="feed.media[0]" style="object-fit: cover;">
        </figure>
      </div>
      <div class="card-content">
        <p class="card-header-title is-paddingless has-text-weight-bold is-size-7" style="color:#f8787f">
          {{feed.created | moment("DD MMMM YYYY")}}
        </p>
        <p class="is-size-6 is-text-overflow has-text-left has-text-weight-bold">{{feed.title}}</p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'feed-new',
  props: ['feed'],
  data () {
    return {
      mainImage: ''
    }
  },
  methods: {},
  mounted () {}
}
</script>

<style scoped>
.card {
  max-width: 300px !important;
  max-height: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.card-footer {
  margin-top: auto;
}
.card-content {
  /* max-height: 470px;*/
  overflow: hidden;
}

.is-text-overflow {
  flex: 1;
  text-overflow: ellipsis;
}
</style>
